import { Fragment, createRef, h } from "preact";
import { useLayoutEffect } from "preact/hooks";
import { format } from "date-fns";

import { humanReadableTimeDiff, renderHtml } from "../../helpers.js";
import i18n from "../../i18n";
import Logo from "../../../static/images/stub_logo_work_Experience.svg";
import initExpandables from "../../oldSchool/initExpandables.js";

import ListItem from "../ListItem.jsx";
import RedactedInfo from "../RedactedInfo.jsx";
import IconButton from "../IconButton.jsx";

export default function WorkExperience({
  editMode,
  experience,
  onEdit,
  previewMode,
}) {
  let { company, companyCity, descriptionHtml, role, from, to } = experience;

  from = from ? new Date(from) : null;
  to = to ? new Date(to) : null;
  const descRef = createRef();
  const timeLine =
    [
      from ? format(from, "LLL, yyyy") : "?",
      to
        ? format(to, "LLL, yyyy")
        : i18n.t("profile_details.work_experience.now"),
    ].join(" – ") +
    (from
      ? " • " + humanReadableTimeDiff(to || new Date(), from || new Date())
      : "");

  useLayoutEffect(() => {
    initExpandables(descRef.current.base);
  }, [descriptionHtml]);

  return (
    <ListItem
      iconOnTop
      iconFront={<Logo />}
      class="t-body4"
      contentClass="work-experience__content"
      ref={descRef}
    >
      <h6 class="t-subtitle1">
        {role}{" "}
        {editMode && (
          <IconButton onClick={() => onEdit(experience)}>edit</IconButton>
        )}
      </h6>
      {company && (
        <p class="mb-0 mt-0">
          {previewMode ? <RedactedInfo inline small w80 /> : company}
        </p>
      )}
      {timeLine && <p class="text-dimmed mb-0 mt-0">{timeLine}</p>}
      {companyCity && <p class="text-dimmed mb-0 mt-0">{companyCity}</p>}
      {descriptionHtml && previewMode && (
        <Fragment>
          <RedactedInfo inline small />
          <br />
          <RedactedInfo inline small />
        </Fragment>
      )}
      {descriptionHtml && !previewMode && (
        <p
          class="work-experience__description"
          key={descriptionHtml}
          data-expandable={2.8 * 16}
          data-expandable-more={i18n.t(
            "profile_details.work_experience.see_more"
          )}
          data-expandable-less={i18n.t(
            "profile_details.work_experience.see_less"
          )}
        >
          {renderHtml(descriptionHtml)}
        </p>
      )}
    </ListItem>
  );
}
